import { FilterActionTypes, SET_FILTER } from "actions/filter.actions";
import dayjs, { Dayjs } from "dayjs";
import { STATUS_OPTIONS } from "features/CrowdSourcePayment/Payments";

import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

interface IEmployeeManagement {
  team_ids: number[];
  designation_ids: number[];
  employee_id: string;
  phone_number: string;
  page: number;
  limit: number;
  order: string;
}

interface ILeaveManagement {
  selected_employee_id: string;
  search: string;
  leave_type_id: number | string;
  leave_start_date: dayjs.Dayjs | null;
  leave_end_date: dayjs.Dayjs | null;
  leave_status: string;
  main_tab: string;
  sub_tab: string;
}

interface IAccessmanagement {
  selected_date: dayjs.Dayjs | null;
  location_id: number;
  page: number;
  limit: number;
  employee_id: string;
  status: string;
}

interface ITicketing {
  category_id: string;
  general_status: number;
  procure_status: number;
  requested_by: string;
  id: string;
  isProcurement: boolean;
}

interface IInventoryManagement {
  asset_category_id: string;
  asset_type_id: string;
  asset_id: string;
  status: string;
  employee_id: string;
}

interface IUserTracking {
  selectedUser: any;
  date: any;
  page: number;
  limit: number;
}

interface INaturalAnchorsPayment {
  paymentsFilters: any;
  withDrawlFilters: any;
  transactionHistoryFilters: any;
  beneficieriesFilters: any;
  mainSectionFilters: any;
}

export interface IFilterState {
  employeeManagement: IEmployeeManagement;
  leaveManagement: ILeaveManagement;
  accessManagement: IAccessmanagement;
  userTracking: IUserTracking;
  ticketsManagement: ITicketing;
  inventoryManagement: IInventoryManagement;
  naturalAnchorsPayment: INaturalAnchorsPayment;
}

const initialState: IFilterState = {
  employeeManagement: {
    team_ids: [],
    designation_ids: [],
    employee_id: "",
    phone_number: "",
    page: 0,
    limit: 10,
    order: "asc",
  },
  leaveManagement: {
    search: "",
    selected_employee_id: "",
    leave_type_id: "all",
    leave_start_date: dayjs().startOf("month") || null,
    leave_end_date: dayjs().endOf("month") || null,
    leave_status: "all",
    main_tab: "leave",
    sub_tab: "pending",
  },
  accessManagement: {
    selected_date: dayjs(),
    location_id: 0,
    page: 0,
    limit: 10,
    employee_id: "",
    status: "",
  },
  ticketsManagement: {
    category_id: "",
    general_status: 0,
    procure_status: 0,
    requested_by: "",
    id: "",
    isProcurement: false,
  },
  inventoryManagement: {
    asset_category_id: "",
    asset_type_id: "",
    asset_id: "",
    status: "All",
    employee_id: "",
  },

  userTracking: {
    selectedUser: "",
    date: dayjs(),
    page: 0,
    limit: 10,
  },
  naturalAnchorsPayment: {
    paymentsFilters: {
      page: 0,
      limit: 20,
      startDate: dayjs().startOf("month"),
      endDate: dayjs().endOf("month"),
      searchQuery: "",
      selectedType: STATUS_OPTIONS[0],
    },
    withDrawlFilters: {
      page: 0,
      limit: 20,
      searchQuery: "",
      startDate: dayjs().startOf("month"),
      endDate: dayjs().endOf("month"),
      selectedType: STATUS_OPTIONS[0],
    },
    transactionHistoryFilters: {
      page: 0,
      limit: 20,
      searchQuery: "",
      // startDate:"2025-10-31T18:30:00+00:00",
      startDate: dayjs().startOf("month"),
      endDate: dayjs().endOf("month"),
      // selectedType: ,
      selectedType: STATUS_OPTIONS[0],

    },
    beneficieriesFilters: {
      page: 0,
      limit: 20,
      searchQuery: "",
    },
    mainSectionFilters:{
      activeTab: "Payments",
    }
  },
};

const filterReducer = (
  state = initialState,
  action: FilterActionTypes
): IFilterState => {
  switch (action.type) {
    case SET_FILTER:
      const { section, filterName, filterValue } = action.payload;
      return {
        ...state,
        [section]: {
          ...state[section],
          [filterName]: filterValue,
        },
      };
    default:
      return state;
  }
};

export default filterReducer;
